// extracted by mini-css-extract-plugin
export default {"container":"checkBox_container__pDsLs","checkmark":"checkBox_checkmark__Fl12J","nocheckmark":"checkBox_nocheckmark__FAiJl"};